import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

import { isClipReady } from "../../model/clipState";
import { formatClock } from "../../model/formatClock";
import type { HighlightView } from "../../model/Highlight";
import { ClipAction, ClipThumb, HighlightSummary, useHighlightTitle } from "../HighlightParts";

const BEST = msg`Best`;
const WATCH = msg`Watch: {title} at {time}`;

type MomentTileProps = {
  highlight: HighlightView;
  clipsEnabled: boolean;
  requesting: boolean;
  // Отметку момента нажали на полосе матча — плитка выделена.
  selected: boolean;
  onOpen: () => void;
  onRequest: () => void;
};

// Плитка момента в матче (доска 18д). Готовый клип — кадр и «смотреть», без клипа — портреты
// героя и врагов на заглушке и «Сделать клип», в записи — статус со спиннером. Под превью —
// что за момент, когда в матче и чем хорош.
export const MomentTile = ({
  highlight,
  clipsEnabled,
  requesting,
  selected,
  onOpen,
  onRequest,
}: MomentTileProps) => {
  const { i18n } = useLingui();
  const title = useHighlightTitle()(highlight);
  const time = formatClock(highlight.game_time_s);
  return (
    <li
      id={`moment-${highlight.id}`}
      className={cn(
        "flex snap-start flex-col gap-2 rounded-xl border bg-background p-2 transition-shadow",
        selected ? "border-accent ring-[3px] ring-accent/25" : "border-sidebar-active",
      )}
    >
      <ClipThumb
        highlight={highlight}
        label={i18n._({ ...WATCH, values: { title, time } })}
        onOpen={onOpen}
        badge={highlight.best ? i18n._(BEST) : undefined}
      />
      <span className="flex flex-col gap-px px-0.5 leading-snug">
        <span className="font-semibold">{title}</span>
        <HighlightSummary
          highlight={highlight}
          compact
          lead={<span className="font-mono">{time}</span>}
          className="text-[13px] text-subtle"
        />
      </span>
      {!isClipReady(highlight) && (
        <ClipAction
          highlight={highlight}
          clipsEnabled={clipsEnabled}
          requesting={requesting}
          onRequest={onRequest}
          className="mt-auto px-0.5"
        />
      )}
    </li>
  );
};
